<nz-spin nzSize="large" [nzSpinning]="loading">
  <form nz-form [nzLayout]="'vertical'" [formGroup]="loginForm" aria-labelledby="sub-title">
    <div class="auth-wrapper">
      <p class="sub-title">Sign in to your account</p>
      <nz-form-item>
        <label for="email" class="auth-label">Email</label>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Email must be a valid email address!">
          <input nz-input autocomplete="email" formControlName="email" id="email"
                 placeholder="Email Address" nzSize="large" autofocus
                 [attr.aria-invalid]="f.email.invalid && f.email.touched ? true : null">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="password-form-item">
        <div class="auth-form-margin">
          <label for="password" class="auth-label">Password</label>
          <a class="login-form-forgot" [routerLink]="['/forgot-password']">Forgot your
            password?</a>
        </div>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Password must be at least 6 characters!">
          <nz-input-group [nzSuffix]="suffixTemplate" nzSize="large">
            <input nz-input autocomplete="password" formControlName="password" type="password" id="password"
                   placeholder="Password" [type]="passwordVisible ? 'text' : 'password'"
                   [attr.aria-invalid]="f.password.invalid && f.password.touched ? true : null">
          </nz-input-group>
          <ng-template #suffixTemplate>
            <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
               (click)="passwordVisible = !passwordVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <div nz-row nzAlign="middle" nzJustify="center">
        <div nz-col nzXs="24" nzSm="16" nzMd="14" nzLg="14" nzXl="14" nzXXl="12">
          <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="loading" id="login-button"
                  [disabled]="submitted" [class.btn-pulse]="submitted" aria-label="Login" (click)="login()">
            Login
          </button>
        </div>
      </div>
      <section class="another-action" aria-label="Sign up">
        Don't have an account? <a class="text-link" id="sign-up-link" [routerLink]="['/register']">Sign up</a>
      </section>
      <nz-divider nzText="OR" class="method-divider"></nz-divider>
      <div nz-row nzAlign="middle" nzJustify="center">
        <div nz-col nzXs="24" nzSm="20" nzMd="18" nzLg="18" nzXl="16" nzXXl="16">
          <button nz-button nzType="primary" nzSize="large" nzBlock class="fcbk-button" (click)="loginWithFacebook()">
            <fa-icon class="fcbk-icon" [icon]="faFacebook"></fa-icon>
            <span class="text">Login with Facebook</span>
            <span class="end"></span>
          </button>
        </div>
      </div>
      <div nz-row nzAlign="middle" nzJustify="center">
        <div nz-col nzXs="24" nzSm="20" nzMd="18" nzLg="18" nzXl="16" nzXXl="16">
          <button nz-button nzType="default" nzSize="large" nzBlock class="google-button" (click)="loginWithGoogle()">
            <span class="icon-wrapper">
              <svg viewBox="0 0 18 18" role="presentation" aria-hidden="true" focusable="false" class="icon">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
                    fill="#EA4335"></path>
                  <path
                    d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
                    fill="#4285F4"></path>
                  <path
                    d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
                    fill="#FBBC05"></path>
                  <path
                    d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
                    fill="#34A853"></path>
                  <path d="M0 0h18v18H0V0z"></path>
                </g>
              </svg>
            </span>
            <span class="text">Login with Google</span>
            <span class="end"></span>
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>
